export default "__VITE_ASSET__Cqwk_KfY__"